import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { BenefitPlan } from '@models/configuration/model';

export type BenefitPlanState = EntityState<BenefitPlan, string>

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'BenefitPlan' })
export class BenefitPlanStore extends EntityStore<BenefitPlanState> {
  constructor() {
    super();
  }
}
